import { useParams } from "react-router-dom";
import { LauraAuditList } from "@/app/components/laura/LauraAuditList";

export default function ProjectLauraPage() {
    const { id } = useParams<{ id: string }>();
    if (!id) return null;
    return <LauraAuditList projectId={id} />;
}
